{
  "page": {
    "heading": "Thông báo",
    "unreadBadge": "{{count}} chưa đọc"
  },
  "categories": {
    "all": "Tất cả",
    "orders": "Đơn hàng",
    "products": "Sản phẩm",
    "stores": "Cửa hàng",
    "vendors": "Nhà cung cấp",
    "billing": "Thanh toán",
    "system": "Hệ thống"
  },
  "filters": {
    "ariaLabel": "Lọc thông báo theo danh mục",
    "unreadOnly": "Chỉ chưa đọc"
  },
  "actions": {
    "markAllRead": "Đánh dấu tất cả đã đọc",
    "markRead": "Đánh dấu đã đọc",
    "dismiss": "Bỏ qua",
    "openDetail": "Mở chi tiết",
    "loadMore": "Tải thêm",
    "loadingMore": "Đang tải…"
  },
  "list": {
    "ariaLabel": "Danh sách thông báo"
  },
  "loading": "Đang tải thông báo…",
  "empty": {
    "body": "Không có thông báo nào."
  },
  "errors": {
    "load": "Lỗi tải thông báo",
    "loadMore": "Lỗi tải thêm thông báo",
    "markRead": "Lỗi cập nhật",
    "dismiss": "Lỗi bỏ qua thông báo",
    "markAllRead": "Lỗi đánh dấu tất cả"
  }
}